import _ from 'lodash'
import Backbone from 'backbone'
import template from './applies-to-filter.hbs'
import EquationAndDateMultiSelector from 'scoreboard/datasets/filters/equation-and-date-multi-selector'
import SpecificDatesFilter from './specific-dates-filter'

const AppliesToDateFilter = Backbone.View.extend({

	className: 'applies-to-date-filter',

	/**
	 * @constructs A view that handles the applies to date portion of a filter
	 *
	 * @param {Object} options.data An object holding the filter data
	 */
	initialize: function(options = {}) {
		this.options = options
		this.options.operatorLabel = 'common.appliesTo'
		this.dateFilter = new SpecificDatesFilter(options)
	},

	render: function() {
		this.$el.html(template())
		this.dateFilter.setElement(this.$('.date-filter-container')).render()
		return this
	},

	/**
	 * Provides validation to this view
	 */
	test: function() {
		return this.dateFilter.test()
	},

	/**
	 * Returns the data gather by the filters used in this view
	 */
	gather: function(e) {
		return this.dateFilter.gather()
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.dateFilter], 'remove')
	}

})

export default AppliesToDateFilter

AppliesToDateFilter.__filename__ = 'reports/common/filter/applies-to-date-filter.js'
